import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import MenuIcon from '@mui/icons-material/Menu';

const navItems = ['Home', 'About', 'Services', 'Our Work', 'Contact'];

const navTargets = {
  Home: 'home',
  About: 'about',
  'Our Work': 'work',
  Services: 'services',
  Contact: 'contact',
};

export default function Navbar({ isLoaded }) {
  const [open, setOpen] = useState(false);

  const toggleDrawer = (nextOpen) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setOpen(nextOpen);
  };

  const handleNav = (key) => {
    const id = navTargets[key];
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      setOpen(false);
      console.warn("No target for navigation:", id);
    }
  };

  return (
    <AppBar position="sticky" elevation={0} sx={{ top: 0, backgroundColor: 'rgba(18,18,18,0.9)', boxShadow: 'none' }}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <AnimatePresence mode="wait">
            {isLoaded ? (
              <motion.div
                key="navbar-brand"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                className="flex items-center gap-3"
              >
                <motion.img
                  layoutId="brand-logo"
                  src="/Logo.jpeg"
                  alt="The Art and Lore Studio logo"
                  className="h-9 w-auto md:h-10"
                />
                <motion.div
                  layoutId="brand-text"
                  className="text-base font-semibold tracking-[0.16em] text-white sm:text-lg md:text-xl"
                >
                  The Art and Lore Studio
                </motion.div>
              </motion.div>
            ) : null}
          </AnimatePresence>
        </Box>

        <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1 }}>
          {navItems.map((item) => (
            <Button
              key={item}
              color="inherit"
              onClick={() => handleNav(item)}
              sx={{ '&:hover': { backgroundColor: 'inherit', color: 'rgb(253 230 138 / 0.9)' } }}
            >
              {item}
            </Button>
          ))}
        </Box>

        <IconButton color="inherit" edge="end" sx={{ display: { xs: 'flex', md: 'none' } }} onClick={toggleDrawer(true)} aria-label="open menu">
          <MenuIcon />
        </IconButton>
      </Toolbar>

      <Drawer anchor="left" open={open} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 260 }} role="presentation" onKeyDown={toggleDrawer(false)}>
          <List>
            {navItems.map((text) => (
              <ListItem key={text} disablePadding>
                <ListItemButton
                  onClick={() => { handleNav(text); setOpen(false); }}
                  sx={{ '&:hover': { backgroundColor: 'rgba(251,191,36,0.35)' } }}
                >
                  <ListItemText primary={text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
}
